import '../../../../@ant-design/cssinjs/es/extractStyle.js';
import '../../../../@ant-design/cssinjs/es/hooks/useCacheToken.js';
import '../../../../rc-util/es/Dom/dynamicCSS.js';
import 'react';
import '../../../../@ant-design/cssinjs/es/StyleContext.js';
import { unit } from '../../../../@ant-design/cssinjs/es/util/index.js';
import '../../../../@ant-design/cssinjs/es/hooks/useCompatibleInsertionEffect.js';
import '../../../../@ant-design/cssinjs/es/hooks/useEffectCleanupRegister.js';
import '../../../../@ant-design/cssinjs/es/hooks/useHMR.js';
import '../../../../@emotion/unitless/dist/unitless.cjs.js';
import '../../../../stylis/dist/umd/stylis.js';
import '../../../../rc-util/es/warning.js';
import '../../../../@ant-design/cssinjs/es/theme/createTheme.js';
import '../../../../@ant-design/cssinjs/es/theme/ThemeCache.js';
import '../../../../@ant-design/cssinjs/es/transformers/legacyLogicalProperties.js';
const genRadiusStyle = token => {
  const {
    componentCls,
    tableRadius
  } = token;
  return {
    [`${componentCls}-wrapper`]: {
      [componentCls]: {
        // https://github.com/ant-design/ant-design/issues/39115#issuecomment-1362314574
        [`${componentCls}-title, ${componentCls}-header`]: {
          borderRadius: `${unit(tableRadius)} ${unit(tableRadius)} 0 0`
        },
        [`${componentCls}-title + ${componentCls}-container`]: {
          borderStartStartRadius: 0,
          borderStartEndRadius: 0,
          // https://github.com/ant-design/ant-design/issues/41975
          [`${componentCls}-header, table`]: {
            borderRadius: 0
          },
          'table > thead > tr:first-child': {
            'th:first-child, th:last-child, td:first-child, td:last-child': {
              borderRadius: 0
            }
          }
        },
        '&-container': {
          borderStartStartRadius: tableRadius,
          borderStartEndRadius: tableRadius,
          'table > thead > tr:first-child': {
            '> *:first-child': {
              borderStartStartRadius: tableRadius
            },
            '> *:last-child': {
              borderStartEndRadius: tableRadius
            }
          }
        },
        '&-footer': {
          borderRadius: `0 0 ${unit(tableRadius)} ${unit(tableRadius)}`
        }
      }
    }
  };
};
var genRadiusStyle$1 = genRadiusStyle;
export { genRadiusStyle$1 as default };
//# sourceMappingURL=radius.js.map
